import { all, put, takeEvery } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from 'index'
import { doApiCall } from 'redux/helpers'
import UserService from 'services/users'
import APP from 'routes'
import actions from './actions'

const service = new UserService()

export function* FETCH_READERS({ payload: { query, path } }) {
  const response = yield doApiCall(service.getAll, { query, path }, actions.SET_STATE)

  if (response.success) {
    yield put({
      type: actions.SET_STATE,
      payload: { list: response.data, pagination: response.meta.pagination },
    })
  }
}
export function* CREATE_READER({ payload }) {
  const { body, path } = payload
  console.log(body)
  const response = yield doApiCall(service.createUser, { body, path }, actions.SET_STATE)
  if (response.success) {
    yield notification.success({
      message: 'Reader Created',
      description: 'You have added reader successfully!',
    })
    yield history.push(APP.USERS_READERS_LIST.path)
  }
}
export function* FETCH_SINGLE_READER({ payload: { path, query } }) {
  const response = yield doApiCall(service.getSingle, { query, path }, actions.SET_STATE)
  console.log(response.data)
  if (response.success) {
    yield put({
      type: actions.SET_STATE,
      payload: { detail: response.data },
    })
  }
}
export function* PERFORM_ACTION_READER({ payload: { path, body } }) {
  const response = yield doApiCall(service.performActionUser, { body, path }, actions.SET_STATE)
  console.log(response.data)
  if (response.success) {
    yield notification.success({
      message: response.data.message,
      // description: response.data.message,
    })
    yield put({
      type: actions.FETCH_SINGLE_READER,
      payload: { path: { alias: 'reader', userId: path.userId } },
    })
    // yield put({
    //   type: actions.SET_STATE,
    //   payload: { detail: response.data },
    // })
    yield history.push(APP.USERS_READERS_LIST.path)
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.FETCH_READERS, FETCH_READERS)])
  yield all([takeEvery(actions.CREATE_READER, CREATE_READER)])
  yield all([takeEvery(actions.FETCH_SINGLE_READER, FETCH_SINGLE_READER)])
  yield all([takeEvery(actions.PERFORM_ACTION_READER, PERFORM_ACTION_READER)])
}
